import { UnifyVersion } from './type/UnifyVersion';

// This value is updated by the bump-unify-version script
// and should not be updated manually.
export const getUnifyVersion = (): UnifyVersion => '14.0';
